export var CustomerPaymentStrategies;
(function (CustomerPaymentStrategies) {
    CustomerPaymentStrategies["postpayment"] = "postpayment";
    CustomerPaymentStrategies["prepayment"] = "prepayment";
})(CustomerPaymentStrategies || (CustomerPaymentStrategies = {}));
export var CustomerStatuses;
(function (CustomerStatuses) {
    CustomerStatuses["active"] = "active";
    CustomerStatuses["inactive"] = "inactive";
    CustomerStatuses["suspended"] = "suspended";
    CustomerStatuses["trial"] = "trial";
    CustomerStatuses["blocked"] = "blocked";
    CustomerStatuses["deleted"] = "DELETED";
})(CustomerStatuses || (CustomerStatuses = {}));
export var CustomerInvoicingStatuses;
(function (CustomerInvoicingStatuses) {
    CustomerInvoicingStatuses["qa"] = "qa";
    CustomerInvoicingStatuses["live"] = "live";
})(CustomerInvoicingStatuses || (CustomerInvoicingStatuses = {}));
//# sourceMappingURL=customer.js.map